import React from "react";
import "./TermsConditions.css";

const TermsConditions = () => {
  return (
    <div className="terms-container">
      <div className="terms-card">
        <h1 className="terms-title">Terms & Conditions</h1>

        <p className="terms-intro">
          Welcome to the official website of Islamic Research Centre Education
          & Welfare Trust (IRC). By accessing and using this website, you agree
          to comply with and be bound by the following terms and conditions.
        </p>

        <section>
          <h2>1. Organization Details</h2>
          <p>
            This website is operated by Islamic Research Centre Education &
            Welfare Trust (IRC), a registered non-governmental organization
            based in Aurangabad (Chhatrapati Sambhajinagar), Maharashtra, India.
          </p>
        </section>

        <section>
          <h2>2. Intellectual Property</h2>
          <p>
            All content on this website, including but not limited to text,
            graphics, logos, images, videos, publications, and digital
            materials, is the property of IRC unless otherwise stated. This
            content is protected by applicable copyright and intellectual
            property laws. Unauthorized use, reproduction, or distribution of
            any material without prior written permission from IRC is strictly
            prohibited.
          </p>
        </section>

        <section>
          <h2>3. Use of Website</h2>
          <p>
            The content provided on this website is for general information,
            educational, and charitable awareness purposes. IRC reserves the
            right to modify, suspend, or discontinue any part of the website or
            its services without prior notice.
          </p>
        </section>

        <section>
          <h2>4. Limitation of Liability</h2>
          <p>
            IRC shall not be held liable for any direct, indirect, incidental,
            or consequential damages arising from the use of, or inability to
            use, this website or any of its content, services, or linked
            resources.
          </p>
        </section>

        <section>
          <h2>5. External Links</h2>
          <p>
            This website may contain links to third-party websites for
            additional information. IRC is not responsible for the content,
            accuracy, or privacy practices of these external websites.
          </p>
        </section>

        <section>
          <h2>6. Governing Law</h2>
          <p>
            These terms and conditions shall be governed by and construed in
            accordance with the laws of India. Any disputes arising in
            connection with the use of this website shall be subject to the
            exclusive jurisdiction of the courts in Maharashtra, India.
          </p>
        </section>

        <section>
          <h2>7. Changes to Terms</h2>
          <p>
            IRC reserves the right to update or modify these terms at any time
            without prior notice. Changes will become effective immediately upon
            being posted on this website. Continued use of the website
            constitutes acceptance of the revised terms.
          </p>
        </section>

        <section>
          <h2>8. Communications</h2>
          <p>
            By using our services and providing your contact details, you agree
            to receive important communications from IRC via phone call, SMS,
            RCS, Email, or WhatsApp regarding programs, activities, services,
            or updates related to our organization.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsConditions;
